var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CTA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.11628C4.19823 1.11628 1.11628 4.19823 1.11628 8C1.11628 11.8018 4.19823 14.8837 8 14.8837C11.8018 14.8837 14.8837 11.8018 14.8837 8C14.8837 4.19823 11.8018 1.11628 8 1.11628ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#688BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60488 4.62862C7.82285 4.41066 8.17624 4.41066 8.39421 4.62862L11.371 7.60537C11.5889 7.82333 11.5889 8.17673 11.371 8.3947L8.39421 11.3714C8.17624 11.5894 7.82285 11.5894 7.60488 11.3714C7.38691 11.1535 7.38691 10.8001 7.60488 10.5821L10.187 8.00003L7.60488 5.41795C7.38691 5.19999 7.38691 4.84659 7.60488 4.62862Z",
    fill: "#688BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46484 7.99997C4.46484 7.69172 4.71473 7.44183 5.02298 7.44183L10.9765 7.44183C11.2847 7.44183 11.5346 7.69172 11.5346 7.99997C11.5346 8.30822 11.2847 8.55811 10.9765 8.55811L5.02298 8.55811C4.71473 8.55811 4.46484 8.30822 4.46484 7.99997Z",
    fill: "#688BFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta);
export default __webpack_public_path__ + "static/media/CTA.df53941b1215f25324df35e9938b0aad.svg";
export { ForwardRef as ReactComponent };